import React from "react";
import {useCreativeStudioTypesQueryQuery} from "../../generated/graphql"; 
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const CreativeStudioTypeSelect = (props) => {
    const query = useCreativeStudioTypesQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}

